<template>
  <div class="tabs-list" :class="{ 'tabs-list--large': isLarge, 'tabs-list--flat': flatDesign }" role="tablist">
    <div
      v-for="tab in tabs"
      :key="tab.id"
      role="tab"
      tabindex="0"
      :aria-selected="String(selected === tab.id)"
      :aria-disabled="tab.disabled ? 'true' : 'false'"
      @click="onSelect(tab)"
      @keydown.enter="onSelect(tab)"
      :class="[
        'tabs-list__tab',
        { 'tabs-list__tab--selected': selected === tab.id, 'tabs-list__tab--disabled': tab.disabled }
      ]"
    >
      {{ tab.title }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      default: () => [
        {id: 'minutes', title: 'Show as minutes'},
        {id: 'hours', title: 'Show as hours'}
      ]
    },
    selected: {
      type: String,
      default: 'minutes'
    },
    isLarge: {
      type: Boolean,
      default: false
    },
    flatDesign: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onSelect (tab) {
      if (tab.disabled) return
      this.$emit('select', tab.id)
    }
  }
}
</script>

<style scoped>
.tabs-list {
  box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, .12) 0px 1px 1px 0px, rgba(64, 68, 82, .16) 0px 0px 0px 1px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(64, 68, 82, .08) 0px 2px 5px 0px;
  border: 0;
  background: #f6f7f8;
  font-weight: 600;
  letter-spacing: .025em;
  border-radius: 4px;
  color: #8898aa;
  padding: 4px;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  height: 28px;
  font-size: 1rem;
}

.tabs-list.tabs-list--flat {
  box-shadow: none;
}

.tabs-list.tabs-list--large {
  font-weight: bold;
  padding: 0.5rem;
}

.tabs-list__tab {
  cursor: pointer;
  padding: 0px 8px;
  min-width: 2.5rem;
  text-align: center;
  transition: background-color 0.2s;
  background-color: #f6f7f8;
  border-color: #d8d8d8;
  border-radius: 4px;
}

.tabs-list.tabs-list--large .tabs-list__tab {
  padding: 2px 12px;
}

.tabs-list__tab--disabled {
  cursor: default;
  opacity: 0.45;
}

.tabs-list__tab--selected {
  color: #09090b;
  background-color: #fff;
  box-shadow:   0 0 0 0 transparent,   /* svarer til --tw-ring-offset-shadow */
  0 0 0 0 transparent,   /* svarer til --tw-ring-shadow */
  0 1px 2px 0 rgba(0, 0, 0, 0.05);;
}
</style>



// WEBPACK FOOTER //
// Tabs.vue?ba4f7d3c